'use strict';

import lightGallery from 'lightgallery.js'; // eslint-disable-line no-unused-vars

export function defochtelLightgallery() {
	'use strict';

	const wrapper = document.querySelector('[data-lightgallery]');

	if (!wrapper) return false;

	const galleryItem = '[data-lightgallery-item]';

	window.lightGallery(wrapper, {
		selector: galleryItem,
		controls: true,
		counter: true,
		hideBarsDelay: 0,
		preload: 3,
		download: false,
		showAfterLoad: true,
	});
}
